import config from 'config';
import { MULESOFT_ORGANIZATION_LINK_ID } from '~/utils/navigation/constants';

const FEATURED_SORT = 'featured';

const shouldHaveFeaturedSort = ({ isAuthenticated, show }) => {
  const showFeaturedOnPrivateExchange = show === MULESOFT_ORGANIZATION_LINK_ID;
  const showFeaturedOnGlobalExchange =
    !show ||
    config.presetLinks.find(({ id: presetShow }) => presetShow === show);

  return isAuthenticated
    ? showFeaturedOnPrivateExchange
    : showFeaturedOnGlobalExchange;
};

export const getSortingOptions = ({ isAuthenticated, show, search } = {}) => {
  const hasFeaturedSort = shouldHaveFeaturedSort({
    isAuthenticated,
    show
  });
  const hasRelevanceSort = !!search;

  const sortingOptions = {
    ...(hasRelevanceSort && {
      score: {
        label: 'Relevance'
      }
    }),
    ...(hasFeaturedSort && {
      featured: {
        label: 'Featured',
        fields: [
          {
            angField: 'assets.AssetNode.ranking',
            order: 'asc'
          },
          {
            angField: 'asset-minor-versions.MinorVersionNode.updatedAt',
            order: 'desc'
          }
        ]
      }
    }),
    name: {
      label: 'Name',
      fields: [
        {
          angField: 'k:assets.AssetNode.name',
          order: 'asc'
        }
      ]
    },
    last: {
      label: 'Last modified',
      fields: [
        {
          angField: 'asset-minor-versions.MinorVersionNode.updatedAt',
          order: 'desc'
        }
      ]
    },
    rating: {
      label: 'Rating',
      fields: [
        {
          angField: 'asset-minor-versions.MinorVersionNode.averageRating',
          order: 'desc'
        }
      ]
    }
  };

  return sortingOptions;
};

export const getDefaultSort = ({ isAuthenticated, show }) => {
  if (
    shouldHaveFeaturedSort({
      isAuthenticated,
      show
    })
  ) {
    return FEATURED_SORT;
  }

  return 'last';
};
